import { name } from "./applications.reducers";

export const selectSlice = (state) => state[name];

export const selectApplications = (state) => selectSlice(state).applications;

export const selectSelectedApp = (state) => selectSlice(state).selectedApp;

export const selectSelectedAppId = (state) => selectSlice(state).selectedAppId;

export const selectShouldShowSidePanel = (state) =>
  selectSlice(state).shouldShowSidePanel;

export const selectShouldShowMenuBar = (state) =>
  selectSlice(state).shouldShowMenuBar;

export const selectSelectedModal = (state) => selectSlice(state).selectedModal;

export const selectTotalApplications = (state) =>
  selectSlice(state).totalApplications;

export const selectApplicationFilters = (state) =>
  selectSlice(state).applicationFilters;

export const selectPredefinedCollections = (state) =>
  selectSlice(state).collections;

export const selectPredefinedProperties = (state) =>
  selectSlice(state).collectionProperties;

export const selectNodes = (state) => selectSlice(state).nodes;

export const selectShouldShowLeftPane = (state) =>
  selectSlice(state).shouldShowLeftPane;

export const selectApplicationsTemplates = (state) =>
  selectSlice(state).applicationsTemplates;

export const selectBackendTemplates = (state) =>
  selectSlice(state).backendTemplates;

export const selectAppDeployStatus = (state) =>
  selectSlice(state).appDeploymentStatus;

export const selectRecentSelectedApp = (state) =>
  selectSlice(state).recentlySelectedApplication;

export const selectAppPipelineStatus = (state) =>
  selectSlice(state).appPipelineStatus;

export const selectApplicationDeploymentsTrack = (state) =>
  selectSlice(state).appDeploymentsTrack
